import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { T, useTranslate } from '@tolgee/react'
import { AlertCircle } from 'lucide-react'

type DeleteAgentDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  agentName: string
  onConfirm: () => void
  isLoading: boolean
}

function DeleteAgentDialog({
  open,
  onOpenChange,
  agentName,
  onConfirm,
  isLoading,
}: DeleteAgentDialogProps) {
  const { t } = useTranslate()
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[425px]'>
        <DialogHeader>
          <DialogTitle className='flex items-start gap-2'>
            <p className='overflow-wrap-anywhere min-w-0 flex-1 break-all'>
              Delete <span className='font-medium'>{agentName}</span>?
            </p>
          </DialogTitle>
        </DialogHeader>
        <div className='space-y-4 font-light'>
          <p>
            <T keyName='agentRegistry.deleteDialog.message' />
          </p>
          <div className='flex gap-4'>
            <AlertCircle color='#CD4848' className='flex-shrink-0' />
            <div className='overflow-wrap-anywhere min-w-0 flex-1 break-all'>
              <T keyName='agentRegistry.deleteDialog.alert' params={{ agentName }} />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant='mango-outline'
            onClick={() => onOpenChange(false)}
            disabled={isLoading}
            title={t('shared.cancelDialog.a11y')}
          >
            <T keyName='agentRegistry.deleteDialog.cancel.title' />
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            title={'agentRegistry.deleteDialog.delete.a11y'}
          >
            <T keyName='agentRegistry.deleteDialog.delete.title' />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export { DeleteAgentDialog }
